

/* ===========================
 السايد منيو تفتح الاقسام ديفولت بدل المنيو

=========================== */
/* ===========================
   فتح الأقسام افتراضيًا
   ونقل تبويب الأقسام إلى اليمين
=========================== */

document.addEventListener("DOMContentLoaded", () => {
  const tab = document.querySelector(
    'hdt-tab[aria-controls="tab-mobile"]'
  );

  if (!tab) return;

  const buttons = tab.querySelectorAll("button");

  if (buttons.length > 1) {
    const menuButton = buttons[0];
    const categoriesButton = buttons[1];

    /* نقل الأقسام قبل القائمة ليظهر على اليمين */
    tab.insertBefore(categoriesButton, menuButton);

    /* فتح الأقسام تلقائيًا */
    setTimeout(() => {
      categoriesButton.click();
    }, 100);
  }
});





/* ===========================
   Mobile Toolbar
=========================== */


/* ===========================
 تعديل زر الاقسام ب الجوال يصير يفتح السايد منيو

=========================== */








/* ===========================
 تعديل زر البحث ب الجوال يصير يفتح  صفحة بحث تطبيق رابيد

=========================== */

document.addEventListener("DOMContentLoaded", () => {
  const bottomSearch = document.querySelector(".hdt-toolbart-search a");

  if (!bottomSearch) return;

  // منع الثيم من فتح الـ Drawer
  bottomSearch.removeAttribute("aria-controls");

  bottomSearch.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const input = document.querySelector("#rps-csb-input");

    if (input) {
      input.focus();
      input.click();
    }
  });
});











/* ===========================
اظهار الليبل المخصص في صفحة المنتج 

=========================== */

(function () {
  "use strict";

  function installBSSKallesFix() {
    /*
     * تحديد حاوية صورة المنتج في Kalles
     */
    window.bssFixSupportProductParent = function (
      $,
      page,
      parents,
      itemHandle
    ) {
      if (page === "products") {
        var $productMedia = $(
          '.hdt-product__media[data-handle="' + itemHandle + '"]'
        ).first();

        if (!$productMedia.length) {
          $productMedia = $(".hdt-product__media[data-handle]").first();
        }

        if ($productMedia.length) {
          return $productMedia;
        }
      }

      return parents;
    };

    /*
     * إضافة الليبل فوق صورة المنتج
     */
    window.bssFixSupportAppendHtmlLabel = function (
      $,
      BSS_PL,
      parent,
      page,
      htmlLabel
    ) {
      if (page !== "products") {
        return false;
      }

      var $parent = $(parent);
      var $mainMedia = $parent.closest(".hdt-product-media__main");

      if (!$mainMedia.length) {
        $mainMedia = $(".hdt-product-media__main").first();
      }

      if (!$mainMedia.length) {
        return false;
      }

      $mainMedia.css("position", "relative");

      /*
       * منع تكرار نفس الليبل
       */
      if (
        !$mainMedia.find(
          ".bss_pl_img, .bss_pb_img, .bss-pl-frontend, [data-bss-pl-label]"
        ).length
      ) {
        $mainMedia.append(htmlLabel);
      }

      return true;
    };

    /*
     * مساعدة التطبيق في التعرف على handle المنتج
     */
    window.bssFixSupportItemHandle = function (
      $,
      page,
      handle,
      handleProductPage,
      prodUrl,
      item,
      isCartPage
    ) {
      if (page === "products") {
        var mediaHandle = $(".hdt-product__media[data-handle]")
          .first()
          .attr("data-handle");

        if (mediaHandle) {
          handle = mediaHandle;
        } else if (handleProductPage) {
          handle = handleProductPage;
        } else {
          handle = window.location.pathname
            .split("/products/")[1]
            ?.split("?")[0]
            ?.split("/")[0];
        }
      }

      return handle;
    };
  }

  /*
   * تثبيت الإصلاح فورًا، ثم تكراره لأن التطبيق يُحمّل Async
   */
  installBSSKallesFix();

  var fixAttempts = 0;

  var fixInterval = setInterval(function () {
    installBSSKallesFix();
    fixAttempts++;

    if (fixAttempts >= 30) {
      clearInterval(fixInterval);
    }
  }, 250);

  /*
   * إعادة تشغيل التطبيق بعد تحميل سكربتاته
   */
  function restartBSSLabels() {
    if (
      window.BSS_PL &&
      Array.isArray(window.BSS_PL.configData) &&
      window.BSS_PL.configData.length
    ) {
      try {
        if (typeof window.bssInitScripts === "function") {
          window.bssInitScripts();
        }
      } catch (error) {
        console.warn("BSS Kalles restart:", error);
      }
    }
  }

  window.addEventListener("load", function () {
    setTimeout(restartBSSLabels, 500);
    setTimeout(restartBSSLabels, 1500);
    setTimeout(restartBSSLabels, 3000);
  });
})();

/* ===========================
 
 اظهار شعار الريال ل المنتج اللي اله
  فارينت لمن يصير عليه تغيير ع الفارينت   
  
=========================== */



document.addEventListener('DOMContentLoaded', function () {
  const symbolTemplate = document.getElementById(
    'sidalih-riyal-symbol-template'
  );

  if (!symbolTemplate) return;

  let updateTimer;

  function restoreRiyalSymbols(scope = document) {
    const moneyElements = scope.querySelectorAll('.hdt-money');

    moneyElements.forEach(function (moneyElement) {
      // لا تضف الشعار إذا كان موجودًا أصلًا
      if (moneyElement.querySelector('.sr-icon')) return;

      // لا تضفه داخل عنصر فارغ
      if (!moneyElement.textContent.trim()) return;

      const symbolClone = symbolTemplate.content.cloneNode(true);
      moneyElement.appendChild(symbolClone);
    });
  }

  // تشغيل عند تحميل الصفحة
  restoreRiyalSymbols();

  function scheduleSymbolUpdate() {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(function () {
      restoreRiyalSymbols();
    }, 50);
  }

  // مراقبة تغيّر السعر عند اختيار الفارينت
  const observer = new MutationObserver(function (mutations) {
    let priceWasUpdated = false;

    mutations.forEach(function (mutation) {
      const targetElement =
        mutation.target.nodeType === Node.ELEMENT_NODE
          ? mutation.target
          : mutation.target.parentElement;

      if (
        targetElement &&
        (
          targetElement.matches?.('.hdt-money, hdt-price, hdt-compare-at-price') ||
          targetElement.closest?.(
            '.hdt-money, hdt-price, hdt-compare-at-price'
          )
        )
      ) {
        priceWasUpdated = true;
      }

      mutation.addedNodes.forEach(function (node) {
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          (
            node.matches?.('.hdt-money, hdt-price, hdt-compare-at-price') ||
            node.querySelector?.('.hdt-money')
          )
        ) {
          priceWasUpdated = true;
        }
      });
    });

    if (priceWasUpdated) {
      scheduleSymbolUpdate();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  // دعم إضافي عند تغيير خيارات الفارينت
  document.addEventListener('change', function (event) {
    if (
      event.target.matches(
        'input[name^="options"], select[name^="options"], input[name="id"], select[name="id"]'
      )
    ) {
      scheduleSymbolUpdate();
    }
  });
});
